import { render, staticRenderFns } from "./downFresh.vue?vue&type=template&id=02e47f2e&scoped=true&lang=html"
import script from "./downFresh.vue?vue&type=script&lang=js"
export * from "./downFresh.vue?vue&type=script&lang=js"
import style0 from "./downFresh.vue?vue&type=style&index=0&id=02e47f2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e47f2e",
  null
  
)

export default component.exports